import React from "react";
import { Helmet } from "react-helmet";
import RegistrationForm from "./components/RegistrationForm";
import SecurityBadges from "./components/SecurityBadges";

const RegisterPage = () => {
  return (
    <>
      <Helmet>
        <title>Create Account - ExpenseLoop</title>
        <meta
          name="description"
          content="Join ExpenseLoop and start managing group expenses with friends, roommates, and colleagues. Create your free account today."
        />
        <meta
          name="keywords"
          content="expense sharing, group expenses, split bills, financial management, register, signup"
        />
        <meta property="og:title" content="Create Account - ExpenseLoop" />
        <meta
          property="og:description"
          content="Join ExpenseLoop and start managing group expenses with friends, roommates, and colleagues."
        />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="/register" />
      </Helmet>
      <div className="min-h-screen bg-background">
        {/* Main Content */}
        <div className="flex flex-col lg:flex-row min-h-screen">
          {/* Left Side - Branding & Info */}
          <div className="hidden lg:flex lg:w-1/2 bg-primary text-primary-foreground p-12 flex-col justify-center">
            <div className="max-w-md">
              <div className="flex items-center space-x-3 mb-8">
                <div className="flex items-center justify-center w-12 h-12 bg-primary-foreground rounded-lg">
                  <img src="assets/images/logo2x.png"></img>
                </div>
                <span className="text-2xl font-bold">ExpenseLoop</span>
              </div>

              <h2 className="text-4xl font-bold mb-6 leading-tight">
                Start Splitting Expenses with Friends
              </h2>

              <p className="text-xl opacity-90 mb-8 leading-relaxed">
                Join thousands of users who trust ExpenseLoop to manage group
                expenses, track balances, and settle debts effortlessly.
              </p>

              <div className="space-y-4">
                <div className="flex items-center space-x-3">
                  <div className="flex items-center justify-center w-8 h-8 bg-white/20 rounded-full">
                    <span className="text-sm">✓</span>
                  </div>
                  <span className="text-lg">
                    Track shared expenses in real-time
                  </span>
                </div>
                <div className="flex items-center space-x-3">
                  <div className="flex items-center justify-center w-8 h-8 bg-white/20 rounded-full">
                    <span className="text-sm">✓</span>
                  </div>
                  <span className="text-lg">
                    Automatic balance calculations
                  </span>
                </div>
                <div className="flex items-center space-x-3">
                  <div className="flex items-center justify-center w-8 h-8 bg-white/20 rounded-full">
                    <span className="text-sm">✓</span>
                  </div>
                  <span className="text-lg">
                    Easy settlement and payment tracking
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Right Side - Registration Form */}
          <div className="flex-1 flex items-center justify-center p-6 lg:p-12">
            <div className="w-full max-w-lg">
              {/* Mobile Header */}
              <div className="lg:hidden text-center mb-8">
                <div className="flex items-center justify-center space-x-3 mb-4">
                  <div className="flex items-center justify-center w-10 h-10 bg-primary rounded-lg">
                    <span className="text-lg font-bold text-primary-foreground">
                      S
                    </span>
                  </div>
                  <span className="text-xl font-bold text-foreground">
                    ExpenseLoop
                  </span>
                </div>
                <p className="text-muted-foreground">
                  The easiest way to split expenses with friends
                </p>
              </div>

              {/* Registration Form Component */}
              <RegistrationForm />

              {/* Security Badges Component */}
              {/* <SecurityBadges /> */}
            </div>
          </div>
        </div>

        {/* Footer */}
        <footer className="bg-muted border-t border-border py-6">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
              <div className="flex items-center space-x-6 text-sm text-muted-foreground">
                <a href="#" className="hover:text-foreground transition-micro">
                  Terms of Service
                </a>
                <a href="#" className="hover:text-foreground transition-micro">
                  Privacy Policy
                </a>
                <a href="#" className="hover:text-foreground transition-micro">
                  Help Center
                </a>
              </div>
              <div className="text-sm text-muted-foreground">
                © {new Date()?.getFullYear()} ExpenseLoop. All rights reserved.
              </div>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default RegisterPage;
